// src/common/getBaseUrl.ts
declare const chrome: any;

export const getBaseUrl = async (): Promise<string> => {
  const isExtension = typeof chrome !== 'undefined' && chrome.storage && chrome.storage.local;

  if (isExtension) {
    return new Promise((resolve) => {
      chrome.storage.local.get(['baseUrl'], (result: any) => {
        let url = result.baseUrl || process.env.REACT_APP_TIMELIVE_API_URL || 'http://localhost:7066/';
        url = url.trim().replace(/\/+$/, ''); 
        resolve(url);
      });
    });
  }

  let savedUrl = localStorage.getItem('baseUrl');
  if (savedUrl) {
    return savedUrl.trim().replace(/\/+$/, '');
  }

  let envUrl = process.env.REACT_APP_TIMELIVE_API_URL || window.location.origin;
  return envUrl.trim().replace(/\/+$/, '');
};